import React, { PureComponent, useState, useEffect } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { nilChart } from "../Utils/demoAnalysis";

const CustomizedDot = (props) => {
  const { cx, cy, stroke, payload, value } = props;

  return <circle cx={cx} cy={cy} r={5} fill={"white"} />;
};

const NILChart = ({ player }) => {
  const chartData = [
    { date: "May 24", amount: 350 },
    { date: "Jun 24", amount: 300 },
    { date: "Jul 24", amount: 400 },
    { date: "Aug 24", amount: 600 },
    { date: "Sep 24", amount: 550 },
    { date: "Oct 24", amount: 550 },
    { date: "Nov 24", amount: 550 },
    { date: "Dec 24", amount: 450 },
    { date: "Jan 25", amount: 450 },
  ];

  return (
    <div className="analysis-line-chart">
      <div style={{ height: "300px" }}>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart
            width={500}
            height={300}
            data={chartData}
            margin={{
              top: 15,
              right: 10,
              left: 5,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" style={{ fill: "white" }} />
            <YAxis
              style={{ fill: "white" }}
              allowDataOverflow={true}
              interval={0}
              tickFormatter={(value, index) =>
                index === 0 ? "" : `$${value}k`
              }
            />
            <Tooltip
              formatter={(value) => [`$${value}k`, "Amount"]}
              contentStyle={{
                backgroundColor: "#1c1c1e",
                border: "1px solid #333",
                color: "white",
              }}
            />

            <Line
              type="monotone"
              dataKey="amount"
              stroke="white"
              dot={<CustomizedDot />}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default NILChart;
